import { createContext, useContext } from "react";

// The default field style is the clean "outlined" look: a sentence-case label
// over a white, lightly-bordered input. Wrap a subtree in <RffFilledFields> to
// opt into the "filled" variant (compact uppercase eyebrow label over a grey
// filled input).
export const RffFieldStyleContext = createContext({ filled: false });

export const useRffFieldStyle = () => useContext(RffFieldStyleContext);
